import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { LogOutFreeServices } from '../../services/log-out.service ';
import { SubscriptionService } from '../../services/subscription.service';
import { AnalyticsUtils } from 'src/app/shared/services/analytics-utils';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-log-out-modale',
    templateUrl: './log-out-modale.component.html',
    styleUrls: ['./log-out-modale.component.scss'],
    standalone: false
})
export class LogOutModaleDayComponent implements OnInit {
   public subscriptions: Subscription[] = [];

   public showLog: boolean = false;
   private isBrowser: boolean;

   constructor(private subscriptionService: SubscriptionService, private auth: AuthService, private logout: LogOutFreeServices,private analyticsUtils:AnalyticsUtils, private router: Router,    public authFire: AngularFireAuth, @Inject(PLATFORM_ID) private platformId: Object) {
      this.isBrowser = isPlatformBrowser(this.platformId);
   }

   ngOnInit(): void {
      let subscription = this.logout.LogOutFreeServices.subscribe(
         (status: boolean) => {
            this.showLog = status;
         }
      );

      this.subscriptions.push(subscription);
      // this.logoutGoogle();
   }

   hideLog() {
      this.logout.hide();
   }

   async goToLogin() {
      this.analyticsUtils.User_Logged_Out();
      this.hideLog();
      // Auth service handles the redirect to SSO logout URL
      await this.logoutGoogle();
      // Don't override the redirect - auth.service.ts already sets window.location.href
   }

   async logoutGoogle() {
      if (!this.isBrowser) return;
      await this.auth.logout();
      this.subscriptionService.clearSubscriptionInfo();
      const user: any = await this.authFire.currentUser;
      user?.delete();
      // await this.authFire.signOut();
      // localStorage.clear()
    }
}
